import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { PendingRequestsService } from '../rest/pending-requests.service';
import { inject } from '@angular/core';

const hasNgswBypass = (req: HttpRequest<unknown>) => req.reportProgress;

export const cancelPendingRequestsInterceptor: HttpInterceptorFn = (req, next) => {
  const pending = inject(PendingRequestsService);
  const isBypassed = hasNgswBypass(req);

  const upstream$ = next(req);

  return isBypassed ? upstream$.pipe(takeUntil(pending.getCancelSignal())) : upstream$;
};
